import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ItemManagement14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M8.96973 5.46967L10.0304 6.53033L6.50006 10.0607L4.46973 8.03033L5.53039 6.96967L6.50006 7.93934L8.96973 5.46967Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.275 1.25C4.39082 0.67944 4.89526 0.25 5.5 0.25H8.5C9.10474 0.25 9.60918 0.67944 9.725 1.25H11.5C12.1904 1.25 12.75 1.80964 12.75 2.5V12.5C12.75 13.1904 12.1904 13.75 11.5 13.75H2.5C1.80964 13.75 1.25 13.1904 1.25 12.5V2.5C1.25 1.80964 1.80964 1.25 2.5 1.25H4.275ZM4.275 2.75H2.75V12.25H11.25V2.75H9.725C9.60918 3.32056 9.10474 3.75 8.5 3.75H5.5C4.89526 3.75 4.39082 3.32056 4.275 2.75ZM5.75 1.75V2.25H8.25V1.75H5.75Z'
      fill='currentColor'
    />
  </Svg>
);

ItemManagement14.displayName = 'ItemManagement14';
export default ItemManagement14;
